var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5n2ockCyvrIw4cIBg9x2U"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["boalingua-cms-ssr@django-stars"]={id:"5n2ockCyvrIw4cIBg9x2U"};
      